// @greenlight-spec: 10-security-compliance.md
// @greenlight-spec: 16-api-conventions.md
// @greenlight-spec: 42-app-marketplace.md
import { initContract } from '@ts-rest/core';
import { z } from 'zod';
import { AppAccessGrantSchema, PaginationQuerySchema, GrantAppAccessByEmailSchema, ReviewAppAccessGrantSchema, paginated, } from '@greenlight/shared';
import { AppIdParamsSchema, errorResponses } from './common.js';
const c = initContract();
const GrantIdParamsSchema = z.object({ grantId: z.string().uuid() });
export const accessRequestsContract = c.router({
    list: {
        method: 'GET',
        path: '/api/apps/:id/access-requests',
        pathParams: AppIdParamsSchema,
        query: PaginationQuerySchema,
        responses: { 200: paginated(AppAccessGrantSchema), ...errorResponses },
        summary: "List an app's access requests/grants — owner/co-owners and IT only.",
    },
    // The owner-initiated half of the same table. Until this existed a person
    // could only be allowed by first requesting and then being approved, so an
    // owner who knew up front who should have access had no way to say so.
    grantByEmail: {
        method: 'POST',
        path: '/api/apps/:id/access-grants',
        pathParams: AppIdParamsSchema,
        body: GrantAppAccessByEmailSchema,
        responses: { 200: AppAccessGrantSchema, ...errorResponses },
        summary: 'Grant a person access to an app by email, without a prior request — app owner/co-owners or IT. Restricts the app if it was open.',
    },
    revokeById: {
        method: 'POST',
        path: '/api/app-access-grants/:grantId/revoke',
        pathParams: GrantIdParamsSchema,
        body: ReviewAppAccessGrantSchema,
        responses: { 200: AppAccessGrantSchema, ...errorResponses },
        summary: 'Revoke a granted app access grant — app owner/co-owners or IT.',
    },
});
//# sourceMappingURL=access-requests.js.map